export default {
  updateFirstAccess: (state, payload) => (state.first_access = payload),
  updateUser: (state, payload) => (state.user = payload),
  updateUserAccount: (state, payload) => {
    state.user = {
      ...state.user,
      ...payload
    }
  },
  updateProvider: (state, payload) => (state.provider = payload),
  updateTenant: (state, payload) => (state.tenant = payload),
  updateDashboard: (state, payload) => (state.dashboard = payload || { available: false }),
  updateToken: (state, payload) => (state.token = payload),
  updatePhoto: (state, payload) => {
    state.photo = payload
    state.user.photo = payload
  },
  updateMessageToast: (state, payload) => (state.messageToast = payload),
  updateAccessTimeNotAllowed: (state, payload) =>
    (state.accessTimeNotAllowed = payload),
  updateEnpsReply: (state, payload) => (state.user.enps.reply = payload),
  updateLastAccessAt: (state, payload) =>
    (state.sessionTime.lastAccessAt = payload),
  updateExpirationTime: (state, payload) =>
    (state.sessionTime.expirationTime = payload),
  updateShouldRenewSession: (state, payload) =>
    (state.sessionTime.shouldRenewSession = payload),
  updateExpirationTimeInSeconds: (state, payload) =>
    (state.sessionTime.expirationTimeInSeconds = payload),
  updateTimeExpired: (state, payload) =>
    (state.sessionTime.timeExpired = payload),
  updateShowModalLogin: (state, payload) =>
    (state.sessionTime.showModalLogin = payload),
  updateCounterStarted: (state, payload) =>
    (state.sessionTime.counterStarted = payload),
  setIsUsingPwa: (state, payload) => (state.isUsingPwa = payload),
  updateIsMobile: (state, payload) => (state.isMobile = payload),
  updateTermOfUseSigned: (state, payload) => (state.termOfUseSigned = payload),
  updateMfaValidated: (state, payload) => (state.mfaValidated = payload),
  setConfirmationType: (state, payload) => (state.confirmationType = payload),
  updateGeolocationRequired: (state, payload) => (state.geolocationRequired = payload),
  setUserEmailValidated: (state, payload) => (state.userEmailValidated = payload),
  setUserPhoneValidated: (state, payload) => (state.userPhoneValidated = payload),
  setCanSkipContactValidation: (state, payload) => (state.canSkipContactValidation = payload),
  setShowModalUserContactsConfirmation: (state, payload) => (state.showModalUserContactsConfirmation = payload),
  setDaysToContactValidationDeadline: (state, payload) => (state.daysToContactValidationDeadline = payload)
}
